import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Button } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import { useExpandCollapseControlsStyles } from 'components/WorkspaceEditor/styles'
import React from 'react'
interface ExpandCollapseButtonProps {
    onExpandAll: () => void
    onCollapseAll: () => void
    isExpanded?: boolean
    disabled?: boolean
}
export const ExpandCollapseButton = ({
    onExpandAll,
    onCollapseAll,
    isExpanded = false,
    disabled = false,
}: ExpandCollapseButtonProps) => {
    const classes = useExpandCollapseControlsStyles()

    return (
        <GridItem>
            {!isExpanded ? (
                <Button
                    disabled={disabled}
                    aria-disabled={disabled}
                    className={classes.expandCollapseButton2}
                    data-testid="btnExpandAll"
                    variant="outlined"
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={onExpandAll}
                    classes={{
                        label: classes.buttonLabel,
                    }}
                    role="button"
                >
                    Expand All
                </Button>
            ) : (
                <Button
                    disabled={disabled}
                    aria-disabled={disabled}
                    className={classes.expandCollapseButton2}
                    data-testid="btnCollapseAll"
                    variant="outlined"
                    endIcon={<KeyboardArrowUpIcon />}
                    onClick={onCollapseAll}
                    classes={{
                        label: classes.buttonLabel,
                    }}
                    role="button"
                >
                    Collapse All
                </Button>
            )}
        </GridItem>
    )
}
